import React from 'react';
import PropTypes from 'prop-types';
import { PopupDisposable } from '@beef/legacy-ui-kit';
import classNames from 'classnames/bind';
import styles from './styles.pcss';

const cx = classNames.bind(styles);

const CommonErrorPopup = ({
  onClose,
  headingText = 'Что-то пошло не так',
  descriptionText = 'Попробуйте повторить через некоторое время',
}) => (
  <PopupDisposable onClose={onClose} className={cx('popup')}>
    <h2 className={cx('popup__heading')}>
      {headingText}
    </h2>
    <div className={cx('popup__description')}>
      {descriptionText}
    </div>
  </PopupDisposable>
);

CommonErrorPopup.propTypes = {
  onClose: PropTypes.func,
  headingText: PropTypes.string,
  descriptionText: PropTypes.string,
};

export default CommonErrorPopup;
